import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import React from "react";
import { Form, Input, Button, Checkbox } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

export default function RegisterPage() {
  const { t } = useTranslation();
    const onFinish = (values: any) => {
        console.log("Form Submit:", values);
    };

    return (
        <>
            <Helmet>
                <title>{t('page.register')} | Khothi</title>
            </Helmet>
        <div className="min-h-screen px-2 flex items-center auth-wrapper">
            <div className="w-full flex justify-center min-h-screen">

                {/* LEFT IMAGE */}
                <div className="hidden lg:flex items-center justify-center p-6 w-[42%] ml-auto">
                    <img
                        src="https://nexlink.layoutdrop.com/php/demo/assets/images/auth/vector2.svg"
                        alt="auth"
                        className="w-[554px] mx-auto img-fluid"
                    />
                </div>

                {/* RIGHT FORM */}
                <div className="flex items-center justify-center px-3 py-3 lg:px-6 lg:py-8 w-full lg:w-[42%] ml-auto">
                    <div className="bg-white w-full max-w-[450px] rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.05)] lg:p-[40px] p-4">

                        {/* Logo */}
                        <div className="text-center mb-6">
                            <a href="/" aria-label="NexLink logo">
                                <img
                                    src="https://nexlink.layoutdrop.com/php/demo/assets/images/logo.svg"
                                    alt="NexLink logo"
                                    className="mx-auto !h-[40px]"
                                />
                            </a>
                        </div>

                        {/* Title */}
                        <div className="text-center mb-[40px]">
                            <h5 className="text-lg !font-semibold !mb-0">
                                Welcome to NexLink
                            </h5>
                            <p className="text-gray-500 text-sm">
                                Sign up to create your secure admin.
                            </p>
                        </div>

                        {/* FORM */}
                        <Form layout="vertical" onFinish={onFinish}>

                            {/* Name */}
                            <Form.Item
                                label="Name"
                                name="name"
                                rules={[{ required: true, message: "Please enter your name" }]}
                            >
                                <Input
                                    size="large"
                                    placeholder="Full Name"
                                    className="rounded-lg"
                                />
                            </Form.Item>

                            {/* Email */}
                            <Form.Item
                                label="Email Address"
                                name="email"
                                rules={[
                                    { required: true, message: "Please enter email" },
                                    { type: "email", message: "Invalid email" },
                                ]}
                            >
                                <Input
                                    size="large"
                                    placeholder="info@example.com"
                                    className="rounded-lg"
                                />
                            </Form.Item>

                            {/* Password */}
                            <Form.Item
                                label="Password"
                                name="password"
                                rules={[{ required: true, message: "Please enter password" }]}
                            >
                                <Input.Password
                                    size="large"
                                    placeholder="********"
                                    iconRender={(visible) =>
                                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                    }
                                    className="rounded-lg"
                                />
                            </Form.Item>

                            {/* Confirm Password */}
                            <Form.Item
                                label="Confirm Password"
                                name="confirmPassword"
                                dependencies={["password"]}
                                rules={[
                                    { required: true, message: "Please confirm your password" },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue("password") === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject("Passwords do not match");
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password
                                    size="large"
                                    placeholder="Re-enter password"
                                    iconRender={(visible) =>
                                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                    }
                                    className="rounded-lg"
                                />
                            </Form.Item>

                            {/* Checkbox */}
                            <Form.Item
                                name="terms"
                                valuePropName="checked"
                                rules={[
                                    {
                                        validator: (_, value) =>
                                            value
                                                ? Promise.resolve()
                                                : Promise.reject("You must agree to terms"),
                                    },
                                ]}
                            >
                                <Checkbox
                                    className="
                                        [&_.ant-checkbox-inner]:!w-[21px]
                                        [&_.ant-checkbox-inner]:!h-[21px]
                                        [&_.ant-checkbox-inner]:!rounded-md
                                        [&_.ant-checkbox-checked_.ant-checkbox-inner]:!bg-[#3e91ab]
                                        [&_.ant-checkbox-checked_.ant-checkbox-inner]:!border-[#3e91ab]
                                    "
                                >
                                    I agree to{" "}
                                    <span className="text-[#3e91ab] cursor-pointer">
                                        privacy policy & terms
                                    </span>
                                </Checkbox>
                            </Form.Item>

                            {/* Submit */}
                            <Form.Item className="!mb-3">
                                <Button
                                    htmlType="submit"
                                    size="large"
                                    type="primary"
                                    className="w-full h-11 rounded-lg !bg-[#3e91ab] !text-sm hover:!bg-[#357f96] border-none"
                                >
                                    Sign up
                                </Button>
                            </Form.Item>

                            {/* Login Link */}
                            <p className="text-center text-sm text-gray-500 !mb-9">
                                Have any account?{" "}
                                <a href="/login" className="!text-[#357f96]">
                                    Sign In here
                                </a>
                            </p>

                            {/* Divider */}
                            <div className="relative text-center !my-6">
                                <div className="border-b border-b-[#EEEEF3]"></div>
                                <span className="absolute left-1/2 bg-white px-3 top-0" style={{ transform: "translate(-50%, -50%)" }}>
                                    Or Continue With
                                </span>
                            </div>

                            {/* Google Button */}
                            <Button
                                size="large"
                                className="
                                    flex items-center justify-center gap-2
                                    !bg-[#f2f2f6]
                                    w-full h-11 rounded-lg
                                    !border-none
                                    text-gray-800
                                    hover:!bg-[#e9ecef]
                                    hover:!border-[#e9ecef]
                                    active:!bg-[#dee2e6]
                                    transition-all
                                    !text-sm
                                    !text-[#0c2c3c]
                                    !font-medium
                                "
                            >
                                <img
                                    src="https://nexlink.layoutdrop.com/php/demo/assets/images/icons/google.svg"
                                    alt="google"
                                    className="w-5"
                                />
                                Login with Google
                            </Button>

                        </Form>
                    </div>
                </div>

            </div>
        </div>
        </>
    );

}